import { Component, inject, input, InputSignal, ChangeDetectionStrategy } from '@angular/core';
import { IconComponent, RadioOptionComponent, ResolvableModal } from '@softline/ui-core';
import { Ticket } from '../../data/ticket.model';
import { ApiResourceLocation, Store } from '@softline/core';
import { DefinitionStore, DynamicModule } from '@softline/dynamic';
import { BehaviorSubject } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { SOFTLINE_API_TICKET_REQUIRED_FIELDS_DEFINITION } from '../../ticket.api';
import { SOFTLINE_FEATURE_DEFINITIONS } from '@softline/dynamic';
import { CommonModule } from '@angular/common';

import { LoadingSpinnerComponent } from '@softline/ui-core';
import { RadioGroupDirective } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
  selector: 'soft-next-step-dialog',
  imports: [
    CommonModule,
    DynamicModule,
    LoadingSpinnerComponent,
    RadioGroupDirective,
    RadioOptionComponent,
    TranslatePipe,
    IconComponent,
  ],
  templateUrl: './next-step-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./next-step-dialog.component.css'],
})
export class NextStepDialogComponent extends ResolvableModal<any> {
  private store = inject(Store);

  step$ = new BehaviorSubject<string | undefined>(undefined);
  definitionName$ = new BehaviorSubject<string | undefined>(undefined);

  ticket = input.required<Ticket>();

  ticketChanges: Partial<InputSignal<Ticket>> | null = null;

  definition$ = this.definitionName$.pipe(
    filter((o) => !!o && o?.length > 0),
    switchMap((name) =>
      this.store.observe(
        SOFTLINE_FEATURE_DEFINITIONS,
        DefinitionStore.getters.definition,
        name
      )
    )
  );

  loading$ = this.store.observe(
    SOFTLINE_FEATURE_DEFINITIONS,
    DefinitionStore.getters.loading
  );

  async onSelectStep(step: string): Promise<void> {
    this.step$.next(step);
    const definitionName = `${this.ticket().id}_${step}`;
    this.definitionName$.next(definitionName);
    const pathParams = {
      id: this.ticket().id,
      step,
    };
    const location: ApiResourceLocation = {
      path: SOFTLINE_API_TICKET_REQUIRED_FIELDS_DEFINITION,
      pathParams,
    };
    const loadParams = {
      name: definitionName,
      location,
    };
    await this.store.dispatch(
      SOFTLINE_FEATURE_DEFINITIONS,
      DefinitionStore.actions.load,
      loadParams
    );
  }

  onRemoveStep() {
    this.step$.next(undefined);
    this.definitionName$.next(undefined);
  }

  async onSubmit(step: string, changes: any = {}): Promise<void> {
    const ticket = { ...this.ticket() };
    for (let [key, value] of Object.entries(changes)) {
      if ((value as any)?.id !== undefined) {
        value = { id: (value as any).id };
      }
      ticket[key] = value;
    }
    const updatedTicket = { ...ticket, ...changes };
    this.resolve({ ticket: updatedTicket, step });
  }
}
